import { gql } from '@apollo/client';

export const CREATE_SECTOR_MUTATOR = gql`
  mutation CreateSectorMutator(
    $master_list: Boolean
    $sectors: [JSON]
    $group_id: String
    $company_id: String
    $user_email: String
  ) {
    createSectors(
      master_list: $master_list
      sectors: $sectors
      group_id: $group_id
      company_id: $company_id
      user_email: $user_email
    )
  }
`;

export const UPDATE_SECTOR_MUTATOR = gql`
  mutation UpdateSectorMutator(
    $master_list: Boolean
    $updated_sector: JSON
    $original_sector: JSON
    $group_id: String
    $company_id: String
    $user_email: String
  ) {
    updateSector(
      master_list: $master_list
      updated_sector: $updated_sector
      original_sector: $original_sector
      group_id: $group_id
      company_id: $company_id
      user_email: $user_email
    )
  }
`;

export const DELETE_SECTOR_MUTATOR = gql`
  mutation DeleteSectorMutator(
    $master_list: Boolean
    $sector_id: String
    $sector_name: String
    $group_id: String
    $company_id: String
    $user_email: String
  ) {
    DeleteSector(
      master_list: $master_list
      sector_id: $sector_id
      sector_name: $sector_name
      group_id: $group_id
      company_id: $company_id
      user_email: $user_email
    )
  }
`;
